
(() => {

    function attach ( root ){

        root
        .querySelectorAll( `template[ shadowrootmode ]` )
        .forEach(( template ) => {

            const mode = template
                .getAttribute('shadowrootmode')

            const host = template.parentNode

            const shadow = host.attachShadow({ mode })
            shadow.appendChild(template.content)

            template.remove()

            attach(shadow)
        })
    }

    function hasSupport (){
        return HTMLTemplateElement.prototype
            .hasOwnProperty('shadowRootMode')
    }

    if( hasSupport() )
        return

    console.log(`Polyfilling ShadowRootMode`)

    attach(document)

})()
